/**
 * Modal com a lista de materiais de campanha para download.
 */

function initDownloads(): void {
  const modal = document.querySelector<HTMLElement>('[data-downloads-modal]')
  if (!modal) return

  const box = modal.querySelector<HTMLElement>('.vd-modal__box')
  let ultimoFoco: HTMLElement | null = null

  const abrir = (): void => {
    ultimoFoco = document.activeElement as HTMLElement
    modal.hidden = false
    void modal.offsetHeight
    modal.dataset.state = 'open'
    document.body.style.overflow = 'hidden'
    box?.focus()
  }

  const fechar = (): void => {
    modal.dataset.state = 'closed'
    document.body.style.overflow = ''
    window.setTimeout(() => {
      modal.hidden = true
    }, 200)
    ultimoFoco?.focus()
  }

  for (const botao of document.querySelectorAll<HTMLElement>(
    '[data-downloads-open]',
  )) {
    botao.addEventListener('click', abrir)
  }

  for (const botao of modal.querySelectorAll<HTMLElement>(
    '[data-downloads-close]',
  )) {
    botao.addEventListener('click', fechar)
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.dataset.state === 'open') fechar()
  })

  /* ── filtro por categoria ─────────────────────────────────── */

  const filtros = modal.querySelectorAll<HTMLButtonElement>('[data-filtro]')
  const itens = modal.querySelectorAll<HTMLElement>('.vd-material')
  const vazio = modal.querySelector<HTMLElement>('[data-materiais-vazio]')

  for (const filtro of filtros) {
    filtro.addEventListener('click', () => {
      const alvo = filtro.dataset.filtro ?? ''

      for (const outro of filtros) {
        outro.setAttribute('aria-pressed', String(outro === filtro))
      }

      let visiveis = 0
      for (const item of itens) {
        const combina = alvo === '' || item.dataset.categoria === alvo
        item.hidden = !combina
        if (combina) visiveis += 1
      }

      if (vazio) vazio.hidden = visiveis > 0
    })
  }
}

document.addEventListener('DOMContentLoaded', initDownloads)
